<template>
  <Groups />
</template>

<script>
import Groups from '@/components/pages/Groups.vue';

export default {
  name: 'SayGroupItinerary',
  components: {
    Groups,
  },
};
</script>
